import Vue from 'vue'
import linkage from './linkage.vue'

const LinkageConstructor = Vue.extend(linkage);

const removeDom = (event) => {
	console.log('event.target:', event.target)
  event.target.parentNode.removeChild(event.target)
};

LinkageConstructor.prototype.close = function (callBack) {
	this.visible = false;
  this.$el.addEventListener('transitionend', removeDom);
	callBack && callBack();
};

const Index = (options = {}) => {
  let instance = new LinkageConstructor().$mount(document.createElement('div'));
  let duration = options.duration || 3000;
	instance.data = options instanceof Array ? options : options.data;
  instance.direction = options.direction || 'leftToRight';
  document.body.appendChild(instance.$el);
  instance.visible = true;
  instance.exportData = null;
  return instance
};
export default Index
